/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    TicketTimeLimitOverrideConfig,
    TicketTimeLimitOverrideConfigFromJSON,
    TicketTimeLimitOverrideConfigToJSON,
    TicketTimeLimitOverrideFormData,
    TicketTimeLimitOverrideFormDataFromJSON,
    TicketTimeLimitOverrideFormDataToJSON,
    TicketTimeLimitOverrideListConfig,
    TicketTimeLimitOverrideListConfigFromJSON,
    TicketTimeLimitOverrideListConfigToJSON,
    TicketTimeLimitOverrideListItem,
    TicketTimeLimitOverrideListItemFromJSON,
    TicketTimeLimitOverrideListItemToJSON,
    TicketTimeLimitOverrideListQuery,
    TicketTimeLimitOverrideListQueryFromJSON,
    TicketTimeLimitOverrideListQueryToJSON,
    TicketTimeLimitOverrideValidationErrors,
    TicketTimeLimitOverrideValidationErrorsFromJSON,
    TicketTimeLimitOverrideValidationErrorsToJSON,
} from '../models';

export interface ApiTicketTimeLimitOverrideGetConfigurationGetRequest {
    brand?: number;
    market?: string;
}

export interface ApiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPostRequest {
    ticketTimeLimitOverrideListQuery?: TicketTimeLimitOverrideListQuery;
}

export interface ApiTicketTimeLimitOverrideIdDeleteRequest {
    id: string;
}

export interface ApiTicketTimeLimitOverrideIdGetRequest {
    id: string;
}

export interface ApiTicketTimeLimitOverridePatchRequest {
    ticketTimeLimitOverrideConfig?: TicketTimeLimitOverrideConfig;
}

export interface ApiTicketTimeLimitOverridePostRequest {
    ticketTimeLimitOverrideConfig?: TicketTimeLimitOverrideConfig;
}

export interface ApiTicketTimeLimitOverrideValidatePostRequest {
    ticketTimeLimitOverrideConfig?: TicketTimeLimitOverrideConfig;
}

/**
 * no description
 */
export class TicketTimeLimitOverrideApi extends runtime.BaseAPI {

    /**
     */
    async apiTicketTimeLimitOverrideGetConfigurationGetRaw(requestParameters: ApiTicketTimeLimitOverrideGetConfigurationGetRequest): Promise<runtime.ApiResponse<TicketTimeLimitOverrideListConfig>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride/GetConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketTimeLimitOverrideListConfigFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTimeLimitOverrideGetConfigurationGet(requestParameters: ApiTicketTimeLimitOverrideGetConfigurationGetRequest): Promise<TicketTimeLimitOverrideListConfig> {
        const response = await this.apiTicketTimeLimitOverrideGetConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPostRaw(requestParameters: ApiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPostRequest): Promise<runtime.ApiResponse<Array<TicketTimeLimitOverrideListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride/GetTicketTimeLimitOverridesList`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketTimeLimitOverrideListQueryToJSON(requestParameters.ticketTimeLimitOverrideListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TicketTimeLimitOverrideListItemFromJSON));
    }

    /**
     */
    async apiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPost(requestParameters: ApiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPostRequest): Promise<Array<TicketTimeLimitOverrideListItem>> {
        const response = await this.apiTicketTimeLimitOverrideGetTicketTimeLimitOverridesListPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTimeLimitOverrideIdDeleteRaw(requestParameters: ApiTicketTimeLimitOverrideIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiTicketTimeLimitOverrideIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTicketTimeLimitOverrideIdDelete(requestParameters: ApiTicketTimeLimitOverrideIdDeleteRequest): Promise<void> {
        await this.apiTicketTimeLimitOverrideIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiTicketTimeLimitOverrideIdGetRaw(requestParameters: ApiTicketTimeLimitOverrideIdGetRequest): Promise<runtime.ApiResponse<TicketTimeLimitOverrideFormData>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiTicketTimeLimitOverrideIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketTimeLimitOverrideFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTimeLimitOverrideIdGet(requestParameters: ApiTicketTimeLimitOverrideIdGetRequest): Promise<TicketTimeLimitOverrideFormData> {
        const response = await this.apiTicketTimeLimitOverrideIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTimeLimitOverridePatchRaw(requestParameters: ApiTicketTimeLimitOverridePatchRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TicketTimeLimitOverrideConfigToJSON(requestParameters.ticketTimeLimitOverrideConfig),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiTicketTimeLimitOverridePatch(requestParameters: ApiTicketTimeLimitOverridePatchRequest): Promise<void> {
        await this.apiTicketTimeLimitOverridePatchRaw(requestParameters);
    }

    /**
     */
    async apiTicketTimeLimitOverridePostRaw(requestParameters: ApiTicketTimeLimitOverridePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketTimeLimitOverrideConfigToJSON(requestParameters.ticketTimeLimitOverrideConfig),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiTicketTimeLimitOverridePost(requestParameters: ApiTicketTimeLimitOverridePostRequest): Promise<string> {
        const response = await this.apiTicketTimeLimitOverridePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiTicketTimeLimitOverrideValidatePostRaw(requestParameters: ApiTicketTimeLimitOverrideValidatePostRequest): Promise<runtime.ApiResponse<TicketTimeLimitOverrideValidationErrors>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/TicketTimeLimitOverride/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TicketTimeLimitOverrideConfigToJSON(requestParameters.ticketTimeLimitOverrideConfig),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => TicketTimeLimitOverrideValidationErrorsFromJSON(jsonValue));
    }

    /**
     */
    async apiTicketTimeLimitOverrideValidatePost(requestParameters: ApiTicketTimeLimitOverrideValidatePostRequest): Promise<TicketTimeLimitOverrideValidationErrors> {
        const response = await this.apiTicketTimeLimitOverrideValidatePostRaw(requestParameters);
        return await response.value();
    }

}
